import { useEffect, useState } from "react";
import { _Inbox, _single } from "../../../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import { toast } from "react-toastify";
import { _CostStudy, _ImportCostSettlement, _NationalizationProcessGeneralInfo, _SupplierPaymentOrder, _SupplierPaymentOrderItem } from "../../../../../../core/services/dataBean/EntityCatalogVdos";
import { BasicButton } from "../../../../../theme/Component/BasicButton";
import { ModalConfirm } from "../../../../../theme/Component/ModalConfirm";
import { MakeUBLInvoice } from "../../../../../contract/etapa-contrato/contrac/ublinvoice/MakeUBLInvoice";
import { ThirdBankingAccountEditor } from "../../../../../Talentohumano/ParametrosTalentoHumano/ThirdBankingAccount/ThirdBanking.editor";
import { InputDate } from "../../../../../theme/Input/InputDate";
import { SelectAdquisitionContract } from "../../../../../RemoteAbstractAction/components/com/quickdataerp/actions/steps/SelectAdquisitionContract";
import { InputMoney } from "../../../../../theme/Input/InputMoney";
import { CurrencyEditor } from "../../../../../erp/cellEditor/Currency/CurrencyEditor";
import { AccountEditor } from "../../../../../editor/AccountEditor";
import { FileInput } from "../../../../../theme/Component/FileInput";
import { NationalizationProcessItemsByStoreProduct } from "../NationalizationProcessItems/NationalizationProcessItemsByStoreProduct";
import { AtachDocument } from "../../../../../theme/Component/AtachDocument";


interface ProcedureFunctions {
    _exportMap: Function;
    _procedure: any;
    _pocessData?: any;
    _pushInfo?: Function;
    _pushProps?: Function;
}

interface Props {
    configProcedure: ProcedureFunctions;
}

export const ACTINV001 = ({ configProcedure }: Props) => {

    const actinuno = useDataBean(_NationalizationProcessGeneralInfo);
    const [invoice, setInvoice] = useState<any>({});
    const [props, setProps] = useState<any>({});
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalConfAdd, setModalConfAdd] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });

    useEffect(() => {
        if (configProcedure?._pocessData?.Props) {
            setProps(configProcedure?._pocessData?.Props)
        }
    }, [configProcedure?._pocessData])
    useEffect(() => {
        console.log("cargando de props => ", props.IDNationalizationProcessGeneralInfo);

        if (props.IDNationalizationProcessGeneralInfo) {
            actinuno.instance.getNationalizationProcessGeneralInfoCatalogPorPropiedades({ IDNationalizationProcessGeneralInfo: props.IDNationalizationProcessGeneralInfo }, null).then(
                (resp: any) => {
                    if (resp.length > 0) {
                        console.log(resp[0].DataBeanProperties);
                        actinuno.setBean(resp[0].DataBeanProperties);
                    }

                }
            )
        }
    }, [props])

    const onExportMap = () => {
        if (configProcedure?._pushInfo) {
            configProcedure?._pushInfo(actinuno.bean.ObservationsEC)
        }

        if (configProcedure?._pushProps) {
            let x = {
                IDNationalizationProcessGeneralInfo: actinuno.bean.IDNationalizationProcessGeneralInfo,
                State: 1
            }
            configProcedure?._pushProps(x)
        }

        if (configProcedure?._exportMap) {
            configProcedure?._exportMap(actinuno.bean)
        }
        toast.success('Actualizado')
    }


    const create = () => {
        actinuno.setBean({
            State: 1,
            Since: _single.getCurrenDate(),
            IDEmployee: _single.getAccountID()
        });
        editaItem()
    }

    const createvdos = () => {
        actinuno.setBean({
            State: 1,
            Since: _single.getCurrenDate(),
            IDEmployee: _single.getAccountID()
        });
        editaItemvdos()
    }

    const editaItem = () => {
        //console.log(entailment.bean);
        actinuno.instance.updateNationalizationProcessGeneralInfo(actinuno.bean).then(
            (resp: any) => {
                onExportMap()
                console.log(resp)
                toast.success('Actualizado');
            }
        ).catch(err => {
            toast.error(err);
        })

    }


    const editaItemvdos = () => {

        actinuno.instance.updateNationalizationProcessGeneralInfo(actinuno.bean).then(
            (resp: any) => {
                console.log(resp);
                toast.success('Actualizado');
                actinuno.setBean(resp);
                configProcedure._pushProps({ IDNationalizationProcessGeneralInfo: resp.IDNationalizationProcessGeneralInfo, State: 1 });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    return (
        <div className="row">
            <div className="col-md-12">


                <div className="row">
                    <div className="col-md-12">

                        <SelectAdquisitionContract data={{ IDAccount: actinuno.bean.IDAccount }} idSelector={actinuno.bean.IDAdquisitionContract} onChange={({ DataBeanProperties }) => { actinuno.setBean({ ...actinuno.bean, 'IDAdquisitionContract': DataBeanProperties.IDAdquisitionContract }) }} />
                    </div>
                    <div className="col-md-6">
                        <label>No. Documento Transporte</label>
                        <input type="text" name="NoDocTransport" className="form-control" value={actinuno.bean.NoDocTransport} onChange={actinuno.handleChange} />
                    </div>
                    <div className="col-md-6">
                        <label>Deposito de la mercancia</label>
                        <input type="text" name="DepositINVM" className="form-control" value={actinuno.bean.DepositINVM} onChange={actinuno.handleChange} />
                    </div>
                    <div className="col-md-6">
                        <label>No. Inventarios de mercancía que se generan</label>
                        <input type="text" name="NoInvetoryINVM" className="form-control" value={actinuno.bean.NoInvetoryINVM} onChange={actinuno.handleChange} />
                    </div>
                    <div className="col-md-6">
                        <label>Ciudad o direccion donde se encuentra el inventario</label>
                        <input type="text" name="PlaceINVM" className="form-control" value={actinuno.bean.PlaceINVM} onChange={actinuno.handleChange} />
                    </div>
                    <div className="col-md-6">
                        <InputDate name="DateINVM" label="Fecha de realización de inventario de la mercancia" value={actinuno.bean.DateINVM} setDate={(e: any) => { actinuno.setBean({ ...actinuno.bean, "DateINVM": e }) }} />
                    </div>
                    <div className="col-md-6">
                        <label>Numero de manifiesto de la carga</label>
                        <input type="text" name="NoManifiestINVM" className="form-control" value={actinuno.bean.NoManifiestINVM} onChange={actinuno.handleChange} />
                    </div>
                    <div className="col-md-6">
                        <InputDate name="ManifestDateINVM" label="Fecha del manifiesto de la mercancía" value={actinuno.bean.ManifestDateINVM} setDate={(e: any) => { actinuno.setBean({ ...actinuno.bean, "ManifestDateINVM": e }) }} />
                    </div>
                    <div className="col-md-6">
                        <label>Nombre de la dependencia o unidad delegada.</label>
                        <input type="text" name="DelegateINVM" className="form-control" value={actinuno.bean.DelegateINVM} onChange={actinuno.handleChange} />
                    </div>
                    <div className="col-md-6">
                        <label>Peso en bruto de la mercancia</label>
                        <input type="text" name="GrossWeightINVM" className="form-control" value={actinuno.bean.GrossWeightINVM} onChange={actinuno.handleChange} />
                    </div>
                    <div className="col-md-6">
                        <CurrencyEditor id={actinuno.bean.CurrencyType} onchange={(e: any) => { actinuno.setBean({ ...actinuno.bean, "CurrencyType": e }) }}></CurrencyEditor>
                    </div>
                    <div className="col-md-6">
                        <FileInput
                            Media={actinuno.bean.Media}
                            MediaContext={actinuno.bean.MediaContext}
                            directory='registrophoto'
                            label='Registros fotográficos de la mercancía X 1'
                            onCreate={({ MediaContext, Media }: any) => { actinuno.setBean({ ...actinuno.bean, "PhotographEvidenceINVM": JSON.stringify({ MediaContext: MediaContext, Media: Media }) }); }}
                        ></FileInput>
                        {/* <AtachDocument _docList={actinuno.bean.PhotographEvidenceINVM} onChange={({ MediaContext, Media }: any) => { actinuno.setBean({ ...actinuno.bean, "PhotographEvidenceINVM": JSON.stringify({ MediaContext: MediaContext, Media: Media }) }); }} /> */}
                    </div>
                    <div className="col-md-6">
                        <FileInput
                            Media={actinuno.bean.Media}
                            MediaContext={actinuno.bean.MediaContext}
                            directory='registrophoto'
                            label='Registros fotográficos de la mercancía X 2'
                            onCreate={({ MediaContext, Media }: any) => { actinuno.setBean({ ...actinuno.bean, "PhotographEvidenceINVM2": JSON.stringify({ MediaContext: MediaContext, Media: Media }) }); }}
                        ></FileInput>
                        {/* <AtachDocument _docList={actinuno.bean.PhotographEvidenceINVM} onChange={({ MediaContext, Media }: any) => { actinuno.setBean({ ...actinuno.bean, "PhotographEvidenceINVM": JSON.stringify({ MediaContext: MediaContext, Media: Media }) }); }} /> */}
                    </div>
                    <div className="col-md-6">
                        <FileInput
                            Media={actinuno.bean.Media}
                            MediaContext={actinuno.bean.MediaContext}
                            directory='registrophoto'
                            label='Registros fotográficos de la mercancía X 3'
                            onCreate={({ MediaContext, Media }: any) => { actinuno.setBean({ ...actinuno.bean, "PhotographEvidenceINVM3": JSON.stringify({ MediaContext: MediaContext, Media: Media }) }); }}
                        ></FileInput>
                        {/* <AtachDocument _docList={actinuno.bean.PhotographEvidenceINVM} onChange={({ MediaContext, Media }: any) => { actinuno.setBean({ ...actinuno.bean, "PhotographEvidenceINVM": JSON.stringify({ MediaContext: MediaContext, Media: Media }) }); }} /> */}
                    </div>
                    <div className="col-md-6">
                        <FileInput
                            Media={actinuno.bean.Media}
                            MediaContext={actinuno.bean.MediaContext}
                            directory='registrophoto'
                            label='Registros fotográficos de la mercancía X 4'
                            onCreate={({ MediaContext, Media }: any) => { actinuno.setBean({ ...actinuno.bean, "PhotographEvidenceINVM4": JSON.stringify({ MediaContext: MediaContext, Media: Media }) }); }}
                        ></FileInput>
                        {/* <AtachDocument _docList={actinuno.bean.PhotographEvidenceINVM} onChange={({ MediaContext, Media }: any) => { actinuno.setBean({ ...actinuno.bean, "PhotographEvidenceINVM": JSON.stringify({ MediaContext: MediaContext, Media: Media }) }); }} /> */}
                    </div>
                    <div className="col-md-6">
                        <InputDate name="IncomeMerchandiseDateINVM" label="Fecha de ingreso de la mercancia" value={actinuno.bean.IncomeMerchandiseDateINVM} setDate={(e: any) => { actinuno.setBean({ ...actinuno.bean, "IncomeMerchandiseDateINVM": e }) }} />
                    </div>
                    <div className="col-md-6">
                        <AccountEditor idAccount={actinuno.bean.MadeByINVM} label="PERSONA/USUARIO que elabora el inventario de la mercancia" onChange={(acc: any) => { actinuno.setBean({ ...actinuno.bean, "MadeByINVM": acc.IDAccount }); }} />
                    </div>
                    <div className="col-md-6">
                        <AccountEditor idAccount={actinuno.bean.ReviewedByINVM} label="PERSONAL/USUARIO que realiza la revisión del inventario de la mercancía" onChange={(acc: any) => { actinuno.setBean({ ...actinuno.bean, "ReviewedByINVM": acc.IDAccount }); }} />
                    </div>
                    <div className="col-md-12">
                        <label>Observaciones</label>

                        <textarea name="ObservationsINVM" className="form-control" value={actinuno.bean.ObservationsINVM} onChange={(e) => { actinuno.setBean({ ...actinuno.bean, 'ObservationsINVM': e.target.value }) }} />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-6">
                        <BasicButton icon="ri-send-plane-fill" clase="primary" eventClick={editaItemvdos}>Guardar Datos*</BasicButton>
                    </div>
                </div>
                {actinuno.bean.IDNationalizationProcessGeneralInfo &&
                    <>
                        <div className="row">
                            {/* <PrintJson json={costestudy.bean} /> */}
                            <NationalizationProcessItemsByStoreProduct IDNationalizationProcessGeneralInfo={actinuno.bean.IDNationalizationProcessGeneralInfo} />
                        </div>
                        <div className="row">
                            <div className="col-md-6">

                                <BasicButton icon="ri-inbox-unarchive-fill" clase="btn rounded-pill btn-warning waves-effect waves-light" eventClick={create}>Finalizar*</BasicButton>
                            </div>
                        </div>
                    </>
                }

            </div>
        </div>
    )
}